import { useState } from "react"
import { createPortal } from "react-dom"
import { useTranslation } from "react-i18next"
import { format, isValid, parseISO } from "date-fns"
import { CircularProgress } from "@mui/material"

import { useNotificationsQuery } from "@/hooks/api/useNoticeQuery"
import LatestNoticeDialog from "@/app/components/latestNoticeDialog/LatestNoticeDialog"
import type { Notice } from "@/types/notice"

function formatNoticeDate(value: string | null | undefined): string {
  if (!value) return "-"
  const d = parseISO(value)
  return isValid(d) ? format(d, "yyyy-MM-dd HH:mm") : "-"
}

export default function NoticeWidget() {
  const { t, i18n } = useTranslation()

  const [selectedNotice, setSelectedNotice] = useState<Notice | null>(null)

  const { data: noticeData, isLoading } = useNotificationsQuery({
    page: 1,
    size: 5,
    language: i18n.language,
  })

  const notices = noticeData?.content ?? []

  return (
    <div className="NoticeWidget">
      <div className="NoticeWidget__list">
        {isLoading ? (
          <div className="NoticeWidget__empty">
            <CircularProgress size={24} />
          </div>
        ) : notices.length === 0 ? (
          <div className="NoticeWidget__empty">{t("noData")}</div>
        ) : (
          notices.map((notice) => (
            <div
              key={notice.idfNotice}
              className="NoticeWidget__item"
              onClick={() => setSelectedNotice(notice)}>
              <span className="NoticeWidget__title">
                {notice.title}
                {!notice.beRead && <span className="NoticeWidget__dot" aria-label="Unread" />}
              </span>
              <span className="NoticeWidget__date">{formatNoticeDate(notice.dateCreated)}</span>
            </div>
          ))
        )}
      </div>

      {selectedNotice &&
        createPortal(
          <LatestNoticeDialog
            {...selectedNotice}
            open={!!selectedNotice}
            onClose={() => setSelectedNotice(null)}
          />,
          document.body,
        )}
    </div>
  )
}
